// Libs
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme, withStyles } from '@material-ui/core/styles';

// Components
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import ResultIcon from 'COMPONENTS/ResultIcon';
import StepperMui from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Box from '@material-ui/core/Box';
import StepConnector from '@material-ui/core/StepConnector';
import IconButton from '@material-ui/core/IconButton';

// Utils
import { checkList } from 'SRC/store';
import {
  NARROW_LAYOUT,
  RUNNING,
  UNKNOWN_LEVEL,
} from 'UTILS/constants';
import { onTrackedClick } from 'UTILS/callbacks';
import { CHECK_ICON_MAP } from 'CHECKS';
import { goToCheck } from 'REDUCERS/navSlice';

const resultIconWrapperStyle = {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const StyledConnector = withStyles((theme) => ({
  line: {
    height: 1,
    border: 0,
    backgroundColor: theme.palette.success.main,
    borderRadius: 1,
  },
  alternativeLabel: {
    left: '-50%',
    right: '50%',
  },
}))(StepConnector);

const StyledLabel = withStyles({
  alternativeLabel: {
    '& .MuiStepLabel-label': {
      marginTop: 0,
    },
  },
})(StepLabel);

const Stepper = () => {
  const theme = useTheme();
  const greyColor = theme.palette.grey;
  const dispatch = useDispatch();
  const isSmallScreen = useSelector(state => state.app.layout === NARROW_LAYOUT);
  const currentCheck = useSelector(state => state.nav.currentCheck);
  const checks = useSelector(state => state.checks);
  const isCheckRunning = useSelector(state => checkList.some(checkLabel => state.checks[checkLabel].stage === RUNNING));
  const currentCheckIndex = checkList.indexOf(currentCheck);

  const StyledStepper = withStyles({
    root: {
      padding: isSmallScreen ? '10px 24px 0' : '24px 24px 10px',
    },
  })(StepperMui);

  const handleCheckIconClick = (checkLabel) => {
    onTrackedClick(`navigate_${checkLabel}`, 'stepper');
    dispatch(goToCheck({ checkLabel }));
  };

  return (
    <Box className='stepper-container'>
      <StyledStepper
        className='stepper-stepper'
        style={{ backgroundColor: greyColor[100] }}
        alternativeLabel
        activeStep={currentCheckIndex}
        connector={<StyledConnector />}
      >
        {checkList.map((label, index) => {
          const { level, stage } = checks[label];
          const Icon = CHECK_ICON_MAP[label];
          const isCurrentCheck = label === currentCheck;
          const checkIconColor = isCurrentCheck ? theme.palette.primary.main : greyColor[700];
          return (
            <Step key={index} completed={level !== UNKNOWN_LEVEL}>
              <StyledLabel icon={
                stage === RUNNING ? (
                  <Box position='relative' display='inline-flex' zIndex={1}>
                    <CircularProgress variant='indeterminate' size='25' />
                    <Box {...resultIconWrapperStyle} >
                      <ResultIcon resultLevel={level} fillColor={greyColor[100]} />
                    </Box>
                  </Box>
                ) : (
                  <Box zIndex={1}>
                    <ResultIcon resultLevel={level} fillColor={greyColor[100]} />
                  </Box>
                )
              }>
                <IconButton
                  className='stepper-labelButton'
                  aria-label={label}
                  disabled={isCheckRunning || isCurrentCheck || level === UNKNOWN_LEVEL}
                  onClick={() => handleCheckIconClick(label)}
                >
                  <Icon htmlColor={checkIconColor} />
                </IconButton>
              </StyledLabel>
            </Step>
          );
        })}
      </StyledStepper>
    </Box>
  );
};

export default Stepper;
